exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mobile-editor[data-v-2b766e9a] {\n  cursor: pointer;\n  font-size: 14px;\n  margin-left: 5px;\n}\n.recharge-overview .iconfont[data-v-2b766e9a] {\n  font-size: 30px;\n  color: #ff5000;\n  margin-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2b766e9a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/sharer/stafftixian/list.vue
// module id = 1328
// module chunks = 0